// Shared color constants used across the app
// Lighter gray used for services sections to match Home "Nuestros Servicios"
export const SERVICES_BG = '#f7f7f7';
